import React, { useState, useEffect, useContext } from 'react'
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import ProductContext from '../context/products/ProductContext'
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { } from '@fortawesome/free-solid-svg-icons/faCartShopping';
import { faArrowLeft, faArrowUp, faXmark, faXmarkCircle } from '@fortawesome/free-solid-svg-icons';
import TermsOfUse from '../pages/TermsOfUse'
import ReactGA from 'react-ga4';

function Cart() {
    //const [cartItems, setCartItems] = useState([]);
    const [couponText, setCouponText] = useState('');
    const [loading, setLoading] = useState(true);
    const [isCouponChecked, setIsCouponChecked] = useState(false);
    const [isCouponValid, setIsCouponValid] = useState(false);
    const [coupon, setCoupon] = useState({});
    const [activeStep, setActiveStep] = useState(1);
    const [paymentMethod, setPaymentMethod] = useState(1);
    const [note, setNote] = useState('')
    const [vinNumber, setVinNumber] = useState('')
    const [message, setMessage] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const [isTermsChecked, setIsTermsChecked] = useState(false)
    const [isModalOpen, setIsModalOpen] = useState(false)
    const phoneRegex = /^0[2-9][0-9]{1}[0-9]{6}$/;
    const API_URL = process.env.REACT_APP_API_URL;
    const analyticsConsent = localStorage.getItem('analyticsConsent');


    const [errors, setErrors] = useState({
        firstName: "",
        lastName: "",
        emailAddress: "",
        phoneNumber: "",
        street: "",
        city: "",
        municipality: "",
        postalCode: "",
    });

    const cities = [
        { value: "", label: "Избери град", disabled: true },
        { value: "Скопје", label: "Скопје" },
        { value: "Битола", label: "Битола" },
        { value: "Берово", label: "Берово" },
        { value: "Валандово", label: "Валандово" },
        { value: "Богданци", label: "Богданци" },
        { value: "Велес", label: "Велес" },
        { value: "Виница", label: "Виница" },
        { value: "Гевгелија", label: "Гевгелија" },
        { value: "Гостивар", label: "Гостивар" },
        { value: "Дебар", label: "Дебар" },
        { value: "Делчево", label: "Делчево" },
        { value: "Демир Хисар", label: "Демир Хисар" },
        { value: "Демир Капија", label: "Демир Капија" },
        { value: "Кавадарци", label: "Кавадарци" },
        { value: "Кичево", label: "Кичево" },
        { value: "Кочани", label: "Кочани" },
        { value: "Кратово", label: "Кратово" },
        { value: "Крива Паланка", label: "Крива Паланка" },
        { value: "Крушево", label: "Крушево" },
        { value: "Куманово", label: "Куманово" },
        { value: "Македонски Брод", label: "Македонски Брод" },
        { value: "Македонска Каменица", label: "Македонска Каменица" },
        { value: "Неготино", label: "Неготино" },
        { value: "Охрид", label: "Охрид" },
        { value: "Прилеп", label: "Прилеп" },
        { value: "Пробиштип", label: "Пробиштип" },
        { value: "Пехчево", label: "Пехчево" },
        { value: "Радовиш", label: "Радовиш" },
        { value: "Ресен", label: "Ресен" },
        { value: "Свети Николе", label: "Свети Николе" },
        { value: "Струга", label: "Струга" },
        { value: "Струмица", label: "Струмица" },
        { value: "Тетово", label: "Тетово" },
        { value: "Штип", label: "Штип" }
    ];

    const municipalities = [
        { value: "", label: "Избери населба", disabled: true },
        { value: "Аеродром", label: "Аеродром", cargoPrice1800: 130, cargoPrice3500: 0 },
        { value: "Центар", label: "Центар", cargoPrice1800: 130, cargoPrice3500: 0 },
        { value: "Карпош", label: "Карпош (1, 2, 3, 4, Злокуќани)", cargoPrice1800: 130, cargoPrice3500: 0 },
        { value: "Козле", label: "Козле", cargoPrice1800: 130, cargoPrice3500: 0 },
        { value: "Кисела Вода", label: "Кисела Вода (Рампа, Чешма, Расадник, Усје)", cargoPrice1800: 130, cargoPrice3500: 0 },
        { value: "Лисиче", label: "Лисиче (населба Лисиче и Горно Лисиче)", cargoPrice1800: 130, cargoPrice3500: 0 },
        { value: "Ново Лисиче", label: "Ново Лисиче", cargoPrice1800: 130, cargoPrice3500: 0 },
        { value: "Ченто", label: "Ченто", cargoPrice1800: 130, cargoPrice3500: 0 },
        { value: "Автокоманда", label: "Автокоманда", cargoPrice1800: 130, cargoPrice3500: 0 },
        { value: "Железара", label: "Железара", cargoPrice1800: 130, cargoPrice3500: 0 },
        { value: "Маџари", label: "Маџари", cargoPrice1800: 130, cargoPrice3500: 0 },
        { value: "Ѓорче Петров", label: "Ѓорче Петров (СП планет до очна болница)", cargoPrice1800: 130, cargoPrice3500: 0 },
        { value: "Хром", label: "Хром", cargoPrice1800: 130, cargoPrice3500: 0 },
        { value: "Влае", label: "Влае", cargoPrice1800: 130, cargoPrice3500: 0 },
        { value: "Пржино", label: "Пржино", cargoPrice1800: 130, cargoPrice3500: 0 },
        { value: "Водно", label: "Водно", cargoPrice1800: 130, cargoPrice3500: 0 },
        { value: "Тафталиџе", label: "Тафталиџе (1 и 2)", cargoPrice1800: 130, cargoPrice3500: 0 },
        { value: "Керамидница", label: "Керамидница", cargoPrice1800: 130, cargoPrice3500: 0 },
        { value: "Чаир", label: "Чаир", cargoPrice1800: 130, cargoPrice3500: 0 },
        { value: "Бутел", label: "Бутел (1 и 2)", cargoPrice1800: 130, cargoPrice3500: 0 },
        { value: "Шуто Оризари", label: "Шуто Оризари", cargoPrice1800: 130, cargoPrice3500: 0 },
        { value: "Други", label: "Друго (населби и општини кои ги нема во листата погоре)", cargoPrice1800: 180, cargoPrice3500: 130 }
    ]


    // Функција за промена
    const handleCityChange = (e) => {
        setCustomerData({
            ...customerData,
            city: e.target.value,
        });
    };

    // Функција за промена
    const handleMunicipalityChange = (e) => {
        setCustomerData({
            ...customerData,
            municipality: e.target.value,
        });
    };

    const { handleDeleteCartItems, setCartItems, cartItems } = useContext(ProductContext)

    const navigate = useNavigate();


    useEffect(() => {
        const cartFromCookies = Cookies.get('cart') ? JSON.parse(Cookies.get('cart')) : [];
        updateStockInCart(cartFromCookies);

        if (analyticsConsent === "true") {
            ReactGA.send({ hitType: "pageview", page: window.location.pathname });
        }

    }, []);

    const handleCouponChange = (e) => setCouponText(e.target.value);

    const handleQuantityChange = (e, id, newQuantity) => {
        const quantity = isNaN(newQuantity) || newQuantity < 1 ? 1 :
            newQuantity > parseInt(e.target.max) ? parseInt(e.target.max)
                : newQuantity;

        const updatedCartItems = cartItems.map((item) =>
            item.id === id
                ? { ...item, quantity, totalPrice: item.price * quantity }
                : item
        );

        setCartItems(updatedCartItems);
        Cookies.set('cart', JSON.stringify(updatedCartItems));
    };

    const totalPrice = cartItems?.length > 0 ? cartItems.reduce((acc, item) => acc + item.totalPrice, 0) : 0;

    const checkIsCouponValid = async () => {
        try {
            const response = await fetch(`${API_URL}/Coupon/checkCoupon?couponNumber=${couponText}`)
            const result = await response.json()
            if (result.data == null) {
                setCouponText('')
                setIsCouponValid(false)
            }
            else {
                setCoupon(result.data)
                setIsCouponValid(result.data.isActive)
            }

            setIsCouponChecked(true)
        }
        catch (error) {
        }
    }

    const nextStep = () => {
        if (analyticsConsent === "true") {
            ReactGA.event({
                category: 'cart',
                action: 'Clicked on Оди на плаќање',
                value: totalPrice
            });
        }

        setActiveStep(2);
    }

    const previousStep = () => {
        setActiveStep(1);
    }

    const [customerData, setCustomerData] = useState({
        firstName: "",
        lastName: "",
        street: "",
        city: "",
        number: "",
        municipality: "",
        country: "Македонија",
        postalCode: "",
        emailAddress: "",
        phoneNumber: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCustomerData({
            ...customerData,
            [name]: value,
        });
    };

    const calculateDiscount = () => {
        if (!isCouponValid) {
            return totalPrice
        }

        const discount = totalPrice * (coupon.ammount / 100);
        const discountedPrice = totalPrice - discount;
        const roundedPrice = Math.round(discountedPrice);

        return roundedPrice;
    }

    const calculateShippingPrice = () => {
        if (totalPrice >= 3500) {
            return 0;
        }

        else if (totalPrice < 1800 && customerData.city === 'Скопје' && customerData.municipality !== 'Други') {
            return 130;
        }
        else if (totalPrice > 1800 && customerData.city === 'Скопје' && customerData.municipality !== 'Други') {
            return 0;
        }
        else if (totalPrice < 1800 && customerData.city === 'Скопје' && customerData.municipality === 'Други') {
            return 180
        }
        else if (totalPrice >= 1800 && totalPrice <= 3500 && customerData.city === 'Скопје' && customerData.municipality === 'Други') {
            return 130
        }

        return 180
    }

    const calculateTotalPrice = () => {
        const price = isCouponValid ? calculateDiscount() : totalPrice;

        const priceToPay = price + calculateShippingPrice()

        return priceToPay;
    }

    const getFormattedPrice = (price) => {
        return new Intl.NumberFormat('mk-MK').format(price);
    }

    const createOrder = async () => {
        const validationErrors = validateInputs();

        if (validationErrors) {
            setErrors(validationErrors);
            return;
        }

        const orderData = {
            "customer": customerData,
            "paymentMethod": paymentMethod,
            "orderItems": cartItems.map(({ id, quantity, selectedCar }) => ({
                itemId: id,
                quantity,
                selectedCar
            })),
            "note": note,
            "vinNumber": vinNumber,
            "coupon": couponText,
        };

        try {
            setLoading(true)

            const response = await fetch(`${API_URL}/order/addOrder`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',  // Specify the content type
                },
                body: JSON.stringify(orderData),
            })

            if (response.ok) {
                const data = await response.json();

                if (data.statusCode === 201) {
                    setLoading(false);
                    clearState();
                    Cookies.remove('cart');
                    setMessage('Вашата порачка беше успешна. Ви благодариме!')
                    toast.success(`Вашата порачка беше успешна. Ви благодариме!`);
                    navigate('/thankyou', { state: { success: true, totalPrice: data.data.order.totalPrice } });
                }
                else {
                    setLoading(false);
                    setErrorMessage('Настана проблем при креирањето на вашата порачка - ' + data.errorMessagesList[0])
                    toast.warning('Настана проблем при креирањето на вашата порачка - ' + data.errorMessagesList[0]);
                }
            } else {
                console.error('Настана проблем при креирањето на нарачката.', response.statusText);
                toast.warning('Настана проблем при креирањето на нарачката.', response.statusText);
                setLoading(false)
            }
        }
        catch (error) {
        }
    }

    const updateStockInCart = async (cartFromCookies) => {
        const updatedCartItems = await Promise.all(cartFromCookies.map(async (item) => {
            try {
                const response = await fetch(`${API_URL}/item/item/${item.id}`);
                const responseData = await response.json()

                const updatedStock = responseData.data.stock;
                const originalPrice = responseData.data.price;
                const discountedPrice = responseData.data.discountedPrice;

                const finalPrice = discountedPrice > 0 ? discountedPrice : originalPrice;

                if (updatedStock < item.quantity) {
                    item.quantity = updatedStock;
                }

                item.stock = updatedStock
                item.price = finalPrice
                item.originalPrice = originalPrice
                item.discountedPrice = discountedPrice
                item.totalPrice = finalPrice * item.quantity



                return {
                    ...item,
                    stock: updatedStock
                };
            } catch (error) {
                console.error("Error fetching updated stock:", error);
                return item;
            }
        }));

        setCartItems(updatedCartItems);

        let expirationTime = new Date();
        expirationTime.setMinutes(expirationTime.getMinutes() + 1440);

        Cookies.set('cart', JSON.stringify(updatedCartItems), { expires: expirationTime }); // чувај во cookies за 7 дена
    };

    const validateInputs = () => {
        const newErrors = {};
        if (!customerData.firstName) newErrors.firstName = "Името е задолжително!";
        if (!customerData.lastName) newErrors.lastName = "Презимето е задолжително!";
        if (!customerData.street) newErrors.street = "Улицата и бројот се задолжителни!";
        if (!customerData.city) newErrors.city = "Градот е задолжителен!";
        if (!customerData.municipality && customerData.city === 'Скопје') newErrors.municipality = "Населбата е задолжителна!";
        if (!customerData.postalCode) newErrors.postalCode = "Поштенскиот код е задолжителен!";
        if (!isTermsChecked) newErrors.isTermsChecked = "Ве молиме прифатете ги условите на користење.";

        if (!customerData.emailAddress) {
            newErrors.emailAddress = "Емаил адресата е задолжителна!";
        } else if (!/\S+@\S+\.\S+/.test(customerData.emailAddress)) {
            newErrors.emailAddress = "Внеси валидна емаил адреса!";
        }

        if (!customerData.phoneNumber) {
            newErrors.phoneNumber = "Телефонот е задолжителен!";
        } else if (!phoneRegex.test(customerData.phoneNumber)) {
            newErrors.phoneNumber = "Внеси валиден телефонски број! Формат: 07x999888";
        }

        return Object.keys(newErrors).length > 0 ? newErrors : null;
    };

    const clearState = () => {
        setCustomerData({});
        setCartItems([]);
        setCouponText('');
        setIsCouponChecked(false);
        setIsCouponValid(false);
        setCoupon({});
        setActiveStep(1);
        setPaymentMethod(1);
        setNote('')
        setVinNumber('')
    }

    const handleCheckboxChange = (event) => {
        setIsTermsChecked(event.target.checked);
    };

    if (cartItems.length === 0) {
        return (<div>Вашата кошничка е празна.</div>)
    }


    return (
        <div>
            {activeStep === 1 && cartItems.length > 0 && (
                <div>
                    <div>
                        <h1 className='text-4xl font-bold mb-8 mt-8 text-center'>Кошничка</h1>
                    </div>
                    <div>
                        <div className="overflow-x-auto">
                            <table className="table max-w-[80%] m-auto ">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Производ</th>
                                        <th>Цена</th>
                                        <th>Количина</th>
                                        <th>Вкупно</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cartItems.map((item) => (
                                        <tr key={item.id} className="odd:bg-white even:bg-gray-200">
                                            <th className='min-w-[80px] w-[120px]'><img src={item.imageLink} alt='Производ' /></th>
                                            <td>{item.title}</td>
                                            <td>{item.originalPrice > item.price ? (
                                                <>
                                                    <span className="line-through text-gray-400 mr-2">{item.originalPrice}</span>
                                                    <span className="text-red-500 font-bold">{item.price} ден</span>
                                                </>
                                            ) : (
                                                <span>{item.price} ден</span>
                                            )}</td>
                                            <td> <input
                                                type="number"
                                                value={item.quantity}
                                                onChange={(e) => handleQuantityChange(e, item.id, parseInt(e.target.value))}
                                                min="1"  // Минимална количина
                                                max={item.stock}
                                                className="w-16 text-center outline-auto border-[3px] rounded"
                                            /></td>
                                            <td>{getFormattedPrice(item.totalPrice)} денари</td>
                                            <td>
                                                <span
                                                    onClick={() => handleDeleteCartItems(item.id)}
                                                    className='text-red-500 font-black cursor-pointer text-xl'>
                                                    X
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                    {isCouponChecked && isCouponValid && (<tr>
                                        <td colSpan="4" className='text-green-600 text-lg'>Купон за попуст</td>
                                        <td className='text-green-600 text-lg'>-{coupon.ammount}% </td>
                                        <td></td>
                                    </tr>)}
                                    <tr>
                                        <td colSpan="4" className='text-lg font-semibold'>Вкупно</td>
                                        <td className='text-lg font-semibold'>{isCouponChecked && isCouponValid ? calculateDiscount() : getFormattedPrice(totalPrice)} денари</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className='flex justify-between flex-wrap max-w-[80%] m-auto'>
                            <div className='w-[100%] md:w-[60%] lg:w-[40%] md:ml-auto lg:ml-px mb-8 mt-10 gap-8'>
                                <div className='relative'>
                                    <input
                                        type='text'
                                        placeholder='Број на купон'
                                        value={couponText}
                                        onChange={handleCouponChange}
                                        className='w-full pr-40 input input-sm text-black focus-outline-0 input-bordered lg:text-xl'
                                    />
                                    <button className='absolute top-0 right-0 btn btn-sm rounded-l-none btn-primary'
                                        onClick={checkIsCouponValid}
                                        disabled={couponText === ''}>Внеси купон</button>
                                    {isCouponChecked && isCouponValid && (<p className='text-green-600'>&#10004; Купонот е валиден.</p>)}
                                    {isCouponChecked && !isCouponValid && (<p className='text-red-600'>X Купонот не е валиден.</p>)}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='flex w-[90%] mt-16'>
                        <button className='btn btn-secondary ml-auto' onClick={nextStep}>Кон плаќање</button>
                    </div>
                </div>
            )}
            {activeStep === 2 && cartItems.length > 0 && (
                <div>
                    <div>
                        <button
                            className="btn btn-third btn-sm"
                            onClick={previousStep}>
                            <FontAwesomeIcon icon={faArrowLeft} />  назад
                        </button>
                    </div>
                    <div className="flex items-center justify-center p-4 flex-wrap">
                        <div className="mx-auto w-full max-w-[450px] md:max-w-[550px] lg:max-w-[450px] xl:max-w-[550px] bg-white mb-auto shadow rounded-xl border border-gray-200 p-2">
                            <div>
                                <h2 className='text-4xl font-bold mb-8 mt-8 text-center'>Податоци за достава</h2>
                            </div>

                            <div className="-mx-3 flex flex-wrap">
                                <div className="w-full px-3 sm:w-1/2">
                                    <div className="mb-5">
                                        <label htmlFor="firstName" className="mb-3 block text-base font-medium text-[#07074D]">
                                            Име<span className='text-red-500 tooltip' data-tip="Името е задолжително">*</span>
                                        </label>
                                        <input type="text" name="firstName" id="firstName"
                                            value={customerData.firstName}
                                            onChange={handleChange}
                                            required
                                            className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" />
                                        {errors.firstName && (
                                            <p className="text-red-500 text-sm mt-2">{errors.firstName}</p>
                                        )}
                                    </div>
                                </div>
                                <div className="w-full px-3 sm:w-1/2">
                                    <div className="mb-5">
                                        <label htmlFor="lastName" className="mb-3 block text-base font-medium text-[#07074D]">
                                            Презиме<span className='text-red-500 tooltip' data-tip="Презимето е задолжително">*</span>
                                        </label>
                                        <input type="text" name="lastName" id="lastName"
                                            value={customerData.lastName}
                                            required
                                            onChange={handleChange}
                                            className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" />
                                        {errors.lastName && (
                                            <p className="text-red-500 text-sm mt-2">{errors.lastName}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="mb-5">
                                <label htmlFor="email" className="mb-3 block text-base font-medium text-[#07074D]">
                                    Емаил<span className='text-red-500 tooltip' data-tip="Емаилот е задолжителен">*</span>
                                </label>
                                <input type="email" name="emailAddress" id="emailAddress"
                                    value={customerData.emailAddress}
                                    required
                                    onChange={handleChange}
                                    className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" />
                                {errors.emailAddress && (
                                    <p className="text-red-500 text-sm mt-2">{errors.emailAddress}</p>
                                )}
                            </div>
                            <div className="mb-5">
                                <label htmlFor="phoneNumber" className="mb-3 block text-base font-medium text-[#07074D]">
                                    Телефон<span className='text-red-500 tooltip' data-tip="Телефонот е задолжителен">*</span>
                                </label>
                                <input type="phone" name="phoneNumber" id="phoneNumber"
                                    value={customerData.phoneNumber}
                                    required
                                    onChange={handleChange}
                                    className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" />
                                {errors.phoneNumber && (
                                    <p className="text-red-500 text-sm mt-2">{errors.phoneNumber}</p>
                                )}
                            </div>
                            <div className="-mx-3 flex flex-wrap">
                                <div className="w-full px-3 sm:w-1/2">
                                    <div className="mb-5">
                                        <label htmlFor="street" className="mb-3 block text-base font-medium text-[#07074D]">
                                            Улица и број<span className='text-red-500 tooltip' data-tip="Улицата и бројот се задолжителни">*</span>
                                        </label>
                                        <input type="text" name="street" id="street" placeholder="Улица, број на куќа/стан"
                                            value={customerData.street}
                                            required
                                            onChange={handleChange}
                                            className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" />
                                        {errors.street && (
                                            <p className="text-red-500 text-sm mt-2">{errors.street}</p>
                                        )}
                                    </div>
                                </div>
                                <div className="w-full px-3 sm:w-1/2">
                                    <div className="mb-5">
                                        <label htmlFor="city" className="mb-3 block text-base font-medium text-[#07074D]">
                                            Град<span className='text-red-500 tooltip' data-tip="Градот е задолжителен">*</span>
                                        </label>
                                        <select
                                            name="city"
                                            value={customerData.city}
                                            onChange={handleCityChange}
                                            className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                                        >
                                            {cities.map((city) => (
                                                <option
                                                    key={city.value}
                                                    value={city.value}
                                                    disabled={city.disabled} // Условно овозможување на disabled
                                                >
                                                    {city.label}
                                                </option>
                                            ))}
                                        </select>

                                        {errors.city && (
                                            <p className="text-red-500 text-sm mt-2">{errors.city}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="-mx-3 flex flex-wrap">
                                {customerData.city == 'Скопје' && (
                                    <div className="w-full px-3 sm:w-1/2">
                                        <div className="mb-5">
                                            <label htmlFor="municipality" className="mb-3 block text-base font-medium text-[#07074D]">
                                                Населба<span className='text-red-500 tooltip' data-tip="Населбата е задолжителна">*</span>
                                            </label>
                                            <select
                                                name="municipality"
                                                value={customerData.municipality}
                                                onChange={handleMunicipalityChange}
                                                className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md"
                                            >
                                                {municipalities.map((municipality) => (
                                                    <option
                                                        key={municipality.value}
                                                        value={municipality.value}
                                                        disabled={municipality.disabled}
                                                    >
                                                        {municipality.label}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.municipality && (
                                                <p className="text-red-500 text-sm mt-2">{errors.municipality}</p>
                                            )}
                                        </div>
                                    </div>
                                )}
                                <div className="w-full px-3 sm:w-1/2">
                                    <div className="mb-5">
                                        <label htmlFor="postalCode" className="mb-3 block text-base font-medium text-[#07074D]">
                                            Поштенски код<span className='text-red-500 tooltip' data-tip="Поштенскиот код е задолжителен">*</span>
                                        </label>
                                        <input type="text" name="postalCode" id="postalCode"
                                            value={customerData.postalCode}
                                            required
                                            onChange={handleChange}
                                            className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" />
                                        {errors.postalCode && (
                                            <p className="text-red-500 text-sm mt-2">{errors.postalCode}</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="-mx-3 flex flex-wrap">
                                <div className="w-full px-3 sm:w-1/2 mx-auto">
                                    <div className="mb-5">
                                        <label htmlFor="country" className="mb-3 block text-base font-medium text-[#07074D]">
                                            Држава
                                        </label>
                                        <input type="text" name="country" id="country" value='Македонија' disabled
                                            className="w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" />
                                    </div>
                                </div>
                            </div>
                            <div className="-mx-3 flex">
                                <div className="w-full px-3 mx-auto">
                                    <div className="mb-5">
                                        <label htmlFor="vinNumber" className="mb-3 block text-base font-medium text-[#07074D]">
                                            Број на Шасија (VIN) - <span className='font-bold'>E</span> ознака од сообраќајната дозвола
                                            <br />
                                            <span className='text-xs text-red-500'>*Внесувате само кога имате додадено филтри во кошничката</span>
                                        </label>
                                        <input name="vinNumber" id="vinNumber"
                                            value={vinNumber}
                                            onChange={(e) => setVinNumber(e.target.value)}
                                            className=" w-full md:w-1/2 mx-auto rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md" />
                                    </div>
                                </div>
                            </div>
                            <div className="-mx-3 flex">
                                <div className="w-full px-3 mx-auto">
                                    <div className="mb-5">
                                        <label htmlFor="note" className="mb-3 block text-base font-medium text-[#07074D]">
                                            Забелешка на нарачка (опционално)
                                        </label>
                                        <textarea name="note" id="note"
                                            value={note}
                                            onChange={(e) => setNote(e.target.value)}
                                            className=" w-full rounded-md border border-[#e0e0e0] bg-white py-2 px-3 text-base font-medium text-[#6B7280] outline-none focus:border-[#6A64F1] focus:shadow-md">

                                        </textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='mx-auto mb-auto w-full max-w-[450px] md:max-w-[550px] lg:max-w-[450px] xl:max-w-[550px] bg-white shadow rounded-xl border border-gray-200 p-2'>
                            <div>
                                <h2 className='text-4xl font-bold mb-8 mt-8 text-center'>Податоци за нарачката</h2>
                            </div>
                            <div >
                                <div className="overflow-x-auto">
                                    <table className="table max-w-[80%] m-auto ">
                                        {/* head */}
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>Производ</th>
                                                <th>Цена</th>
                                                <th>Количина</th>
                                                <th>Вкупно</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cartItems.map((item) => (
                                                <tr key={item.id} className="odd:bg-white even:bg-gray-200">
                                                    <th className='min-w-[80px] w-[120px]'><img src={item.imageLink} alt='Производ' /></th>
                                                    <td>{item.title}</td>
                                                    <td>{getFormattedPrice(item.price)}</td>
                                                    <td>{item.quantity}</td>
                                                    <td>{getFormattedPrice(item.totalPrice)} денари</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className='mt-10'>
                                    <div>
                                        <p className='text-2xl color-gray-600 text-center'>Вкупно за наплата</p>
                                    </div>
                                    <div className='mt-12'>
                                        <div className='flex flex-wrap'>
                                            <div className='flex justify-between w-full ml-2 mr-2 border-b p-[10px]'>
                                                <div className='text-l font-bold'>Износ</div>
                                                <div className='font-semibold'>{getFormattedPrice(totalPrice)} денари</div>
                                            </div>
                                            {isCouponChecked && isCouponValid &&
                                                <div className='flex justify-between w-full ml-2 mr-2 border-b p-[10px]'>
                                                    <div className='text-l font-bold'>Купон за попуст</div>
                                                    <div className='font-semibold'>{coupon.ammount}%</div>
                                                </div>}
                                            {isCouponChecked && isCouponValid &&
                                                <div className='flex justify-between w-full ml-2 mr-2 border-b p-[10px]'>
                                                    <div className='text-l font-bold'>Цена со попуст</div>
                                                    <div className='font-semibold'>{getFormattedPrice(calculateDiscount())} денари</div>
                                                </div>}
                                            <div className='flex justify-between w-full ml-2 mr-2 border-b p-[10px]'>
                                                <div className='text-l font-bold'>Достава</div>
                                                <div className='font-semibold'>{calculateShippingPrice() === 0 ? 'Бесплатна достава' : calculateShippingPrice() + 'денари'}</div>
                                            </div>
                                            <div className='flex justify-between w-full ml-2 mr-2 border-b p-[10px]'>
                                                <div className='text-xl font-bold'>Вкупно за плаќање</div>
                                                <div className='font-semibold text-xl'>{getFormattedPrice(calculateTotalPrice())} денари</div>
                                            </div>
                                            <div className=' w-full ml-2 mr-2 mt-6 p-[10px]'>
                                                <div>
                                                    <p className='w-full text-xl'>Начин на плаќање</p>
                                                </div>

                                                <div className="w-full">
                                                    <label className="label cursor-pointer">
                                                        <input type="radio" name="paymentOption" id="paymentOption" className="radio radio-xs checked:bg-orange-500" defaultChecked value='CashOnDelivery' />
                                                        <span className="label-text w-full ml-[20px] text-l font-semibold">Плаќање во готовина (кеш) при преземање</span>
                                                    </label>
                                                </div>
                                            </div>
                                            <div className='flex justify-between w-full ml-2 mr-2 mt-6 p-[10px]'>
                                                <p className='text-sm'>Вашите лични податоци ќе се користат за обработка на вашата нарачка, за поддршка на вашето искуство низ оваа веб-страница и за други цели опишани во нашата политика за приватност.</p>
                                            </div>
                                            <div className=' w-full ml-2 mr-2 mt-6 p-[10px]'>
                                                <div className="form-control">
                                                    <label className=" label">
                                                        <input type="checkbox"
                                                            name='isTermsChecked'
                                                            className="checkbox-sm mr-[20px] accent-myOrange"
                                                            checked={isTermsChecked}
                                                            onChange={handleCheckboxChange} />
                                                        <span className="label-text mr-auto">Ги имам прочитано и се согласувам со <p onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            setIsModalOpen(true);
                                                        }} className='cursor-pointer hover:text-blue-700 hover:underline text-blue-500 inline'>услови на користење</p> *</span>
                                                    </label>
                                                    {errors.isTermsChecked && (
                                                        <p className="text-red-500 text-sm mt-2 ml-3"><FontAwesomeIcon icon={faArrowUp} /> {errors.isTermsChecked}</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='flex w-full pb-6 pt-6'>
                                        <button
                                            className="btn btn-secondary py-3 px-6 mx-auto text-center text-base font-semibold text-white outline-none"
                                            onClick={createOrder}>
                                            Направи нарачка
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className='text-center'>
                                {isCouponChecked && isCouponValid && (<p className='text-green-600 text-sm'>Купонот кој го искористивте е валиден и имате {coupon.ammount}% попуст.</p>)}
                                {Object.keys(errors).map((key) => (
                                    errors[key] && (
                                        <p key={key} className="text-red-500 text-sm mt-2">
                                            {errors[key]}
                                        </p>
                                    )
                                ))}

                                {errorMessage && (<p className='text-red-600 text-sm'>{errorMessage}</p>)}
                                {message && (<p className='text-blue-600 text-sm'>{message}</p>)}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {isModalOpen && (<div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                <div className="modal modal-open">
                    <div className="modal-box max-w-[800px] relative">
                        <div className="sticky top-0 right-0 ml-[98%] p-2"> {/* Овде ја поставуваме на горниот десен агол */}
                            <FontAwesomeIcon
                                icon={faXmarkCircle}
                                className="text-xl cursor-pointer hover:text-blue-500"
                                onClick={() => setIsModalOpen(false)}
                            />
                        </div>
                        <TermsOfUse className="bg-red-500" />
                        <div className="w-full flex justify-end">
                            <button className="btn btn-primary btn-sm btn-outline" onClick={() => setIsModalOpen(false)}>Затвори</button>
                        </div>
                    </div>
                </div>

            </div>)}
        </div>
    )
}

export default Cart
